export default __webpack_public_path__ + "static/media/Group 6360.f9d22a99.svg";